import { generateTestId } from "@client-shared";

export const setAppHeaderTestId = (identifier: string): string =>
  generateTestId("AppHeader", identifier);

export const setAppHeaderSearchTestId = (): string =>
  generateTestId("AppHeader", "search-input");

export const setAppHeaderSearchResultTestId = (index: number): string =>
  generateTestId("AppHeader", `search-result-${index}`);
